import React from 'react';

export default class ListingHeader extends React.PureComponent {

    render() {
        return (
            <div className="listing__header">
                <div className="listing__header-inner">
                    {this.props.children}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/components/listing/js/ListingHeader.js